module.exports = __webpack_public_path__ + "img/11.187f39d0.jpg";